import { BlazeError } from '@blaze-cms/core-errors';

function variantMapHandler() {
  const variants = new Map();

  function get(key) {
    return variants.get(key);
  }

  function getAll() {
    return Array.from(variants.entries());
  }

  function add(key, variant) {
    validate(key, variant);
    variants.set(key, variant);
  }

  function validate(key, variant) {
    if (!key || !variant) throw new BlazeError('Variant requires key and component');
    // eslint-disable-next-line no-console
    if (variants.has(key) && key !== 'array') console.warn(`Variant already exists: ${key}`); // todo: restore error // throw new BlazeError(`Variant already exists: ${key}`);
  }

  return {
    add,
    get,
    getAll
  };
}

const variantHandler = variantMapHandler();

export default variantHandler;
